import { parseEntities, parseEntity } from '@/shared/converters/commonConverters';
import { TAG_SCHEMA } from '@/shared/converters/tagConverters';
import DossierStack from '../models/DossierStack';

const SCHEMA = {
  ...TAG_SCHEMA,
  size: 'dossierCount',
  isPersonal: (data: any) => data.isPersonalStack ?? false,
};

export function parseDossierStack(data: any): DossierStack | null {
  return parseEntity(data, SCHEMA, DossierStack);
}

export function parseDossierStacks(data: any): Array<DossierStack> {
  return parseEntities(data, SCHEMA, DossierStack);
}